export type SortDirection = 'asc' | 'desc'

export interface SortState {
  columnId: string
  direction: SortDirection
}

export type SortValue = string | number | boolean | Date | null | undefined

const collator = new Intl.Collator('en-GB', { numeric: true, sensitivity: 'base' })

function compareValues(a: SortValue, b: SortValue): number {
  const aEmpty = a === null || a === undefined || a === ''
  const bEmpty = b === null || b === undefined || b === ''
  if (aEmpty || bEmpty) return aEmpty === bEmpty ? 0 : aEmpty ? 1 : -1
  if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime()
  if (typeof a === 'number' && typeof b === 'number') return a - b
  if (typeof a === 'boolean' && typeof b === 'boolean') return Number(a) - Number(b)
  return collator.compare(String(a), String(b))
}

/** Stable sort; empty values always sink to the bottom regardless of direction. */
export function sortRows<Row>(
  rows: readonly Row[],
  value: (row: Row) => SortValue,
  direction: SortDirection,
): Row[] {
  const sign = direction === 'asc' ? 1 : -1
  return rows
    .map((row, index) => ({ row, index, key: value(row) }))
    .sort((a, b) => {
      const aEmpty = a.key === null || a.key === undefined || a.key === ''
      const bEmpty = b.key === null || b.key === undefined || b.key === ''
      if (aEmpty !== bEmpty) return aEmpty ? 1 : -1
      return sign * compareValues(a.key, b.key) || a.index - b.index
    })
    .map((entry) => entry.row)
}

/** Header click cycle: unsorted → ascending → descending → ascending… */
export function nextSort(current: SortState | null, columnId: string): SortState {
  if (current?.columnId === columnId) {
    return { columnId, direction: current.direction === 'asc' ? 'desc' : 'asc' }
  }
  return { columnId, direction: 'asc' }
}
